module.exports = __webpack_public_path__ + "static/media/EarthID Logo - Primary - BLACK.b4cfd4b7.png";